import axios from 'axios';
import config from '../config';
import { RouteCardOperationsUpdateRequestBody, RouteCardOperationsUpdateResponse } from '../interfaces';

export const patchRouteCardOperations = (
    id: string,
    request: RouteCardOperationsUpdateRequestBody,
): Promise<RouteCardOperationsUpdateResponse> => {
    return axios.patch(`${config.API_URL}/route-cards/${id}/operations`, request).then((response: any) => {
        return response.data.data;
    });
};
